var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-view"},[_c('div',{ref:"mapView",staticClass:"main-map"}),_c('i',{staticClass:"el-icon-close map-close",on:{"click":_vm.hiddenView}})])}
var staticRenderFns = []

export { render, staticRenderFns }